import { vault_category_types, vault_tag_types } from "./enums";

export const getVaultCategoryLabel = (key) =>
  vault_category_types[key];

export const vaultCategoryOptions = Object.entries(vault_category_types).map(
  ([key, label]) => ({
    value: key,
    label,
  })
);
  
export const vaultTagOptions = Object.entries(vault_tag_types).map(
  ([key, label]) => ({
    value: key,
    label,
  })
);